document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth >= 750) {
        const productGrid = document.querySelector('#product-grid')

        const toggleFacets = (increaseGridColumns) => {
            document.querySelector('.facets-vertical-form').classList.toggle('hidden-facets')
            document.querySelector('.facets-wrapper').classList.toggle('hidden')

            const gridColumnClass = productGrid.classList.value.match(/grid--\d-col-desktop/)
            if (gridColumnClass) {
                const currentColumnCount = parseInt(gridColumnClass[0].slice(6, -12))
                const newColumnCount = increaseGridColumns ? currentColumnCount + 1 : currentColumnCount - 1
                productGrid.classList.replace(gridColumnClass[0], `grid--${newColumnCount}-col-desktop`)
            }
        }

        document.querySelector('.active-facets-vertical-filter .desktop-facets__open').addEventListener('click', () => toggleFacets(true))
        document.querySelector('.facets-vertical-form .desktop-facets__open').addEventListener('click', () => toggleFacets(false))
    }
})